module.exports = __webpack_public_path__ + "static/media/icon_selected_charts.a2773500.svg";